export const RATING = "rating";
export const YES_NO = "yes_no";
